@if (id && id.sid?.keyName) {
<div sxPadding="medium">

  @if (id.sid.keyName == sidKeys.pan) {
  <div sxBackgroundImage="assets/pan-bg.png" sxBgPosition="top" sxBgSize="cover" sxRadius="medium">
    <div sxHeight="60px"></div>
    <p sxWidth="full" sxTextAlign="center" sxTextSize="10px" sxTextWeight="bold">
      Permanent Account Card Number <br> <span sxTextSize="20px">{{documentData.idNumber}}</span></p>
    <p sxTextSize="10px" sxTextWeight="bold" sxMargin="small medium">Name <br> <span
        sxTextSize="14px">{{documentData?.fullName}}</span></p>
    <p sxTextSize="10px" sxTextWeight="bold" sxMargin="small medium">Date of Birth <br> <span
        sxTextSize="14px">{{documentData?.dob}}</span></p>
    <div sxHeight="30px"></div>
  </div>
  }

  @if (id.sid.keyName == sidKeys.aadhaar) {
  <div sxBackground="light" sxCol sxRadius="medium" class="doc-card-wrapper" sxPadding="medium">
    <img src="assets/adhr-header.png" alt="Aadhaar Header">
    <div sxRow>
      <img sxHeight="120px" sxMargin="large 0 0" [src]="ImageUtil.getImageSource(documentData.userPhotoURL)">
      <div sxCol sxDistribution="start" sxAlign="start" sxWidth="fill" sxPadding="medium">
        <p sxMargin="0">{{documentData?.fullName}}</p>
        <p sxMargin="0">DOB: {{documentData?.dob}}</p>
        <p sxMargin="0">{{documentData?.gender}}</p>
        <p sxMargin="5px 0 0 0" sxTextSize="12px">{{documentData?.careOf}}</p>
        <p sxMargin="0" sxTextSize="12px">{{getAddressLine()}}</p>
      </div>
    </div>
    <div>
      <h1 sxWidth="full" sxTextSize="24px" sxTextAlign="center">{{getStyledIdNumber(documentData?.idNumber)}}</h1>
    </div>
    <img sxWidth="full" src="assets/imgs/img.png" alt="Aadhaar Footer">
  </div>
  }

  @if (id.sid.keyName == sidKeys.dl) {
  <div sxBackgroundImage="assets/imgs/dl-bg.png" sxBgPosition="top" sxBgSize="cover" sxCol sxAlign="stretch"
    sxRadius="medium" class="doc-card-wrapper" sxPadding="medium">

    <div sxCol sxAlign="stretch">
      <h2 sxTextAlign="center" sxTextSize="16px"><span sxMargin=" 0 5px 0 0" sxTextSize="12px">UNION OF
          INDIA</span>Driving
        License</h2>
      <h3 sxMargin="5px 0" sxTextWeight="bold" sxTextSize="18px" sxTextAlign="center">{{documentData.idNumber}}</h3>
    </div>

    <div sxRow sxDistribution="spaceBetween" sxAlign="center">
      <div sxCol>
        <img sxWidth="70px" src="assets/imgs/card-chip.png">
      </div>
      <div sxWidth="fill" sxRow sxPadding="0 15px">
        <div sxCol sxWidth="fill">
          <div>
            <p sxMargin="2px 0" sxTextSize="10px">Date of Issue</p>
            <h2 sxTextSize="12px">{{documentData.doi}}</h2>
          </div>
          <div>
            <p sxMargin="2px 0" sxTextSize="10px">Date of Birth</p>
            <h2 sxTextSize="12px">{{documentData.dob}}</h2>
          </div>
        </div>
        <div sxCol sxWidth="fill">
          <div>
            <p sxMargin="2px 0" sxTextSize="10px">Validity</p>
            <h2 sxTextSize="12px">{{documentData.expiry}}</h2>
          </div>
          <div>
            <p sxMargin="2px 0" sxTextSize="10px">Blood Group</p>
            <h2 sxTextSize="12px">{{documentData.extra.blood_group}}</h2>
          </div>
        </div>
      </div>
      <img sxHeight="100px" src="data:image/png;base64,{{documentData.userPhotoURI}}">
    </div>

    <div sxRow>
      <div sxWidth="fill">
        <p sxMargin="2px 0" sxTextSize="10px">Name</p>
        <h2 sxTextSize="12px">{{documentData.fullName}}</h2>
      </div>
      <div sxWidth="fill">
        <p sxMargin="2px 0" sxTextSize="10px">Son/Daughter/Wife of</p>
        <h2 sxTextSize="12px">{{documentData.careOf}}</h2>
      </div>
    </div>

    <div sxRow sxGap="10px" sxAlign="end">
      <p sxMargin="0" sxTextSize="10px">Vehicle Classes:</p>
      @for (vc of documentData.extra.vehicle_classes; track vc) {
      <p sxMargin="0" sxTextSize="12px" sxTextWeight="bold">
        {{vc}}</p>
      }
    </div>
    <div sxWidth="fill">
      <p sxMargin="2px 0" sxTextSize="10px">Address</p>
      <h2 sxTextSize="12px">{{documentData.address.addressLine}}</h2>
    </div>


  </div>
  }

</div>
}
